import type { CodeRuleAuditConcern, ConcernSeverity } from "@/api/codeRuleAudits";
import { Badge } from "@/components/ui/badge";

function severityVariant(severity: ConcernSeverity): "destructive" | "default" | "secondary" {
  switch (severity) {
    case "high":
      return "destructive";
    case "medium":
      return "default";
    case "low":
      return "secondary";
  }
}

export function ConcernCard({ concern }: { concern: CodeRuleAuditConcern }) {
  return (
    <li className="rounded-md border border-border bg-card p-3 space-y-2">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex items-center gap-2 flex-wrap">
          {concern.relatedCodes.map((code) => (
            <code key={code} className="text-sm font-mono font-semibold">
              {code}
            </code>
          ))}
          <Badge variant="outline">{concern.codeType}</Badge>
        </div>
        <Badge variant={severityVariant(concern.severity)}>{concern.severity}</Badge>
      </div>

      <blockquote className="border-l-2 border-border pl-3 text-sm italic text-muted-foreground">
        {concern.ruleExcerpt}
      </blockquote>

      <p className="text-sm">{concern.reasoning}</p>

      {concern.suggestedAction ? (
        <p className="text-sm">
          <span className="font-medium">Suggested:</span> {concern.suggestedAction}
        </p>
      ) : null}
    </li>
  );
}
